import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';

export interface IResourceEventType extends IBaseEntity {
    id?: number;
    name?: string;
    defaultDescription?: string;
    resourceSubject?: string;
    colour?: string;
    workBlocker?: boolean;
    workshopBlocker?: boolean;
    approvalRequired?: boolean;
    showDriverTypes?: boolean;
}

export class ResourceEventType extends BaseEntity implements IResourceEventType {
    public id?: number;
    public name?: string;
    public defaultDescription?: string;
    public resourceSubject?: string;
    public colour?: string;
    public workBlocker?: boolean;
    public workshopBlocker?: boolean;
    public approvalRequired?: boolean;
    public showDriverTypes?: boolean;

    constructor(resourceEventType?: any) {
        super();
        if (resourceEventType) {
            this.id = resourceEventType.id;
            this.name = resourceEventType.name;
            this.defaultDescription = resourceEventType.defaultDescription;
            this.resourceSubject = resourceEventType.resourceSubject;
            this.colour = resourceEventType.colour;
            this.workBlocker = resourceEventType.workBlocker;
            this.workshopBlocker = resourceEventType.workshopBlocker;
            this.approvalRequired = resourceEventType.approvalRequired;
            this.showDriverTypes = resourceEventType.showDriverTypes;
        }
    }

    get discriminator(): any {
        return this.name;
    }

    clone(): ResourceEventType {
        return new ResourceEventType(this);
    }
}
